export type ApiErrorMessages = Record<string, string>

export const apiErrorsEn: ApiErrorMessages = {
  default: 'Unknown error, please contact the administrator',
  '400': 'Request parameter is invalid: {0}',
  '401': 'Account is not logged in',
  '403': 'You do not have permission to perform this operation',
  '404': 'Requested resource was not found',
  '405': 'Request method is not allowed',
  '423': 'Request failed, please try again later',
  '429': 'Too many requests, please try again later',
  '500': 'Internal server error',
  '501': 'Feature is not implemented or not enabled',
  '502': 'Invalid configuration',
  '900': 'Duplicate request, please try again later',
  '901': 'Write operations are not allowed in demo mode',
  '999': 'Unknown error',
  '1001000001': 'Parameter configuration does not exist',
  '1001000002': 'Parameter configuration key is duplicated',
  '1001000003': 'System built-in parameter configurations cannot be deleted',
  '1001000004': 'Failed to get the parameter configuration because invisible configurations are not allowed to be read',
  '1001001000': 'Scheduled job does not exist',
  '1001001001': 'The scheduled job handler already exists',
  '1001001002': 'Only enabled or disabled status is allowed',
  '1001001003': 'The scheduled job is already in this status',
  '1001001004': 'Only enabled jobs can be modified',
  '1001001005': 'CRON expression is invalid',
  '1001001006': 'The scheduled job handler bean does not exist. Note that the bean name usually starts with a lowercase letter',
  '1001001007': 'The scheduled job handler bean type is invalid because it does not implement the JobHandler interface',
  '1001002000': 'API error log does not exist',
  '1001002001': 'API error log has already been processed',
  '1001003000': 'File path already exists',
  '1001003001': 'File does not exist',
  '1001003002': 'File is empty',
  '1001004001': 'The imported table does not exist',
  '1001004002': 'The imported columns do not exist',
  '1001004004': 'Table definition does not exist',
  '1001004005': 'Column definition does not exist',
  '1001004006': 'The synchronized columns do not exist',
  '1001004007': 'Synchronization failed because there are no changes',
  '1001004008': 'The table comment in the database is missing',
  '1001004009': 'The comment for database column ({0}) is missing',
  '1001004010': 'Master table definition (id={0}) does not exist. Please check',
  '1001004011': 'Sub-table column (id={0}) does not exist. Please check',
  '1001004012': 'Failed to generate code for the master table because it has no sub-table',
  '1001006000': 'File configuration does not exist',
  '1001006001': 'This file configuration cannot be deleted because it is the primary configuration and deleting it would prevent file uploads',
  '1001007000': 'Data source configuration does not exist',
  '1001007001': 'Data source configuration is invalid and the connection cannot be established',
  '1001201000': 'Demo contact does not exist',
  '1001201001': 'Demo category does not exist',
  '1001201002': 'The demo category has child categories and cannot be deleted',
  '1001201003': 'Parent demo category does not exist',
  '1001201004': 'A demo category cannot be its own parent',
  '1001201005': 'A demo category with this name already exists',
  '1001201006': 'A child demo category cannot be set as the parent category',
  '1001201007': 'Student does not exist',
  '1001201008': 'Student course does not exist',
  '1001201009': 'Student class does not exist',
  '1001201010': 'Student class already exists',
  '1002000000': 'Login failed, incorrect username or password',
  '1002000001': 'Login failed, account is disabled',
  '1002000004': 'The verification code is incorrect, reason: {0}',
  '1002000005': 'No account is bound. Please bind an account first',
  '1002000007': 'Mobile number does not exist',
  '1002000008': 'The verification code is incorrect, reason: {0}',
  '1002001000': 'A menu with this name already exists',
  '1002001001': 'Parent menu does not exist',
  '1002001002': 'A menu cannot be its own parent',
  '1002001003': 'Menu does not exist',
  '1002001004': 'The menu has child menus and cannot be deleted',
  '1002001005': 'The parent menu type must be directory or menu',
  '1002001006': 'A menu with this component name already exists',
  '1002002000': 'Role does not exist',
  '1002002001': 'A role named [{0}] already exists',
  '1002002002': 'A role with code [{0}] already exists',
  '1002002003': 'System built-in roles cannot be modified',
  '1002002004': 'The role named [{0}] is disabled',
  '1002002005': 'The code [{0}] cannot be used',
  '1002003000': 'The username already exists',
  '1002003001': 'The mobile number already exists',
  '1002003002': 'The email already exists',
  '1002003003': 'User does not exist',
  '1002003004': 'Imported user data cannot be empty',
  '1002003005': 'User password validation failed',
  '1002003006': 'The user named [{0}] is disabled',
  '1002003008': 'Failed to create the user because the tenant quota ({0}) has been exceeded',
  '1002003009': 'Initial password cannot be empty',
  '1002003010': 'This mobile number has not been registered',
  '1002003011': 'Registration is disabled',
  '1002003012': 'An approver must be selected when deleting an admin or cadmin user',
  '1002003013': 'Email cannot be modified',
  '1002003014': 'The current group does not exist',
  '1002003015': 'You are not allowed to select the current group',
  '1002003016': 'The current role is not allowed to create users',
  '1002003017': 'The new password cannot be the same as the current password.',
  '1002004000': 'A tenant with this name already exists',
  '1002004001': 'Parent tenant does not exist',
  '1002004002': 'The current tenant does not exist',
  '1002004003': 'The tenant has child tenants and cannot be deleted',
  '1002004004': 'A tenant cannot be its own parent',
  '1002004006': 'Tenant ({0}) is not enabled and cannot be selected',
  '1002004007': 'A child tenant cannot be set as the parent tenant',
  '1002004008': 'The real-time device count exceeds the remaining container quota ({0})',
  '1002004009': 'The non-real-time device count exceeds the remaining container quota ({0})',
  '1002005000': 'The current post does not exist',
  '1002005001': 'Post ({0}) is not enabled and cannot be selected',
  '1002005002': 'A post with this name already exists',
  '1002005003': 'A post with this code already exists',
  '1002006001': 'The current dictionary type does not exist',
  '1002006002': 'The dictionary type is not enabled and cannot be selected',
  '1002006003': 'A dictionary type with this name already exists',
  '1002006004': 'A dictionary type with this type already exists',
  '1002006005': 'The dictionary type cannot be deleted because it still has dictionary data',
  '1002007001': 'The current dictionary data does not exist',
  '1002007002': 'Dictionary data ({0}) is not enabled and cannot be selected',
  '1002007003': 'Dictionary data with this value already exists',
  '1002008001': 'The current notice does not exist',
  '1002011000': 'SMS channel does not exist',
  '1002011001': 'SMS channel is not enabled and cannot be selected',
  '1002011002': 'The SMS channel cannot be deleted because it still has SMS templates',
  '1002012000': 'SMS template does not exist',
  '1002012001': 'An SMS template with code [{0}] already exists',
  '1002012002': 'SMS API template call failed, reason: {0}',
  '1002012003': 'The SMS API template cannot be used because it is under review',
  '1002012004': 'The SMS API template cannot be used because the review was rejected: {0}',
  '1002012005': 'The SMS API template cannot be used because the template does not exist',
  '1002013000': 'Mobile number does not exist',
  '1002013001': 'Template parameter ({0}) is missing',
  '1002013002': 'SMS template does not exist',
  '1002014000': 'Verification code does not exist',
  '1002014001': 'Verification code has expired',
  '1002014002': 'Verification code has already been used',
  '1002014004': 'Daily SMS sending limit exceeded',
  '1002014005': 'SMS messages are being sent too frequently',
  '1002018000': 'Social authorization failed, reason: {0}',
  '1002018001': 'Social authorization failed because the corresponding user was not found',
  '1002018200': 'Failed to obtain the mobile number',
  '1002018201': 'Failed to obtain the mini program code',
  '1002018202': 'Failed to obtain the mini program subscription template',
  '1002018203': 'Failed to send the mini program subscription message',
  '1002018204': 'Failed to upload WeChat Mini Program shipping information',
  '1002018205': 'Failed to upload WeChat Mini Program order receipt information',
  '1002018210': 'Social client does not exist',
  '1002018211': 'A social client configuration already exists',
  '1002020000': 'OAuth2 client does not exist',
  '1002020001': 'OAuth2 client ID already exists',
  '1002020002': 'OAuth2 client is disabled',
  '1002020003': 'The authorization grant type is not supported',
  '1002020004': 'The requested scope is too broad',
  '1002020005': 'Invalid redirect_uri: {0}',
  '1002020006': 'Invalid client_secret: {0}',
  '1002021000': 'client_id does not match',
  '1002021001': 'redirect_uri does not match',
  '1002021002': 'state does not match',
  '1002022000': 'code does not exist',
  '1002022001': 'code has expired',
  '1002023000': 'Mail account does not exist',
  '1002023001': 'The mail account cannot be deleted because it is still used by mail templates',
  '1002024000': 'Mail template does not exist',
  '1002024001': 'Mail template code ({0}) already exists',
  '1002025000': 'Template parameter ({0}) is missing',
  '1002025001': 'Email does not exist',
  '1002026000': 'Notification template does not exist',
  '1002026001': 'A notification template with code [{0}] already exists',
  '1002028000': 'Template parameter ({0}) is missing',
  '1002029000': 'Approval token is invalid or expired',
  '1002029001': 'Approval data is invalid',
  '1002029002': 'Approval record does not exist',
  '1002029003': 'Applicant information does not match',
  '1002029004': 'Approval record status is invalid',
  '1002029005': 'All approval notification channels are disabled. Please enable at least one notification method',
  '1002029006': 'An approver must be specified when sending an in-app approval notification',
  '1002030000': 'The current container does not exist',
  '1002030001': 'A container with this name already exists',
  '1002030002': 'A container with this unique ID already exists',
  '1002030003': 'You are not allowed to select the current container',
  '1050001000': 'Device type does not exist',
  '1050001001': 'Device type key already exists',
  '1050001002': 'The device type status is released and deletion is not allowed',
  '1050001003': 'The device type status is released and the thing model cannot be modified',
  '1050001004': 'The device type cannot be deleted because devices still exist under it',
  '1050001005': 'Approver cannot be the current login user',
  '1050002000': 'Thing model does not exist for this device type',
  '1050002001': 'A thing model already exists for the specified deviceTypeKey',
  '1050002002': 'Duplicate function identifier exists',
  '1050002003': 'Thing model identifier is invalid',
  '1050003000': 'Device does not exist',
  '1050003001': 'Device name must be unique within the same device type',
  '1050003002': 'The device has child devices and cannot be deleted',
  '1050003003': 'Device key already exists',
  '1050003004': 'Gateway device does not exist',
  '1050003005': 'The device is not a gateway device',
  '1050003006': 'Imported device data cannot be empty',
  '1050003007': 'Failed to send a downstream device message because the device is not connected to the gateway',
  '1050003008': 'Device serial number already exists and must be globally unique',
  '1050003009': 'Only 3, 6, 12, and 24 months are supported for the extension duration',
  '1050003010': 'No expiring devices were found in the current filter scope',
  '1050003011': 'Device usage rights extension request does not exist',
  '1050003012': 'Device usage rights extension request status is invalid',
  '1050003013': 'Failed to approve the device usage rights extension request',
  '1050003014': 'Approver email cannot be empty',
  '1050003015': 'Only 3, 6, 12, and 24 months are supported for the reactivation duration',
  '1050003016': 'No inactive devices were found in the current filter scope',
  '1050003017': 'Device usage rights reactivation request does not exist',
  '1050003018': 'Device usage rights reactivation request status is invalid',
  '1050003019': 'Failed to approve the device usage rights reactivation request',
  '1050003020': 'Approver email cannot be empty',
  '1050003021': 'No deletable devices were found in the current filter scope',
  '1050003022': 'Device deletion request does not exist',
  '1050003023': 'Device deletion request status is invalid',
  '1050003024': 'Approver email cannot be empty',
  '1050003025': 'Only Inactive or Off-boarding devices can be deleted',
  '1050004000': 'Device type category does not exist',
  '1050005000': 'Device group does not exist',
  '1050005001': 'The device group cannot be deleted because devices still exist under it',
  '1050005002': 'The device type cannot be changed because devices already exist in this group',
  '1050005003': 'The real-time device count exceeds the remaining tenant quota ({0})',
  '1050005004': 'The non-real-time device count exceeds the remaining tenant quota ({0})',
  '1050008000': 'Firmware does not exist',
  '1050008001': 'Duplicate device type firmware version',
  '1050008100': 'OTA task does not exist',
  '1050008101': 'Failed to create the OTA task because the task name is duplicated',
  '1050008102': 'Failed to create the OTA task because device ({0}) is already being upgraded',
  '1050008103': 'Failed to create the OTA task because no upgradable devices were found',
  '1050008104': 'Failed to cancel the OTA task because the task is not in progress',
  '1050008200': 'OTA task record does not exist',
  '1050008201': 'Failed to cancel the OTA task record because the record is not in progress',
  '1050008202': 'Failed to update OTA task record progress because the device has no OTA record in progress',
  '1050010000': 'Data rule does not exist',
  '1050011000': 'Data sink does not exist',
  '1050011001': 'The data sink cannot be deleted because it is used by a data rule',
  '1050012000': 'Rule scene does not exist',
  '1050013000': 'IoT alert configuration does not exist',
  '1050014000': 'IoT alert record does not exist',
  '1051001000': 'Device authentication failed',
  '1051001002': 'Token has expired. Please call auth again to re-authenticate and obtain a new token',
  '1051002001': 'Device ({0}/{1}) does not exist'
}

export const apiErrorsZh: ApiErrorMessages = {
  ...apiErrorsEn,
  default: '未知错误，请联系管理员',
  '400': '请求参数不正确：{0}',
  '1002000000': '登录失败，账号密码不正确',
  '1002000001': '登录失败，账号被禁用',
  '1002000004': '验证码不正确，原因：{0}',
  '1002000005': '未绑定账号，需要进行绑定',
  '1002000007': '手机号不存在',
  '1002000008': '验证码不正确，原因：{0}',
  '1002001000': '已经存在该名字的菜单',
  '1002001001': '父菜单不存在',
  '1002001002': '不能设置自己为父菜单',
  '1002001003': '菜单不存在',
  '1002001004': '存在子菜单，无法删除',
  '1002001005': '父菜单的类型必须是目录或者菜单',
  '1002001006': '已经存在该组件名的菜单',
  '1002002000': '角色不存在',
  '1002002001': '已经存在名为【{0}】的角色',
  '1002002002': '已经存在标识为【{0}】的角色',
  '1002002003': '不能操作类型为系统内置的角色',
  '1002002004': '名字为【{0}】的角色已被禁用',
  '1002002005': '标识【{0}】不能使用',
  '1002003000': '用户账号已经存在',
  '1002003001': '手机号已经存在',
  '1002003002': '邮箱已经存在',
  '1002003003': '用户不存在',
  '1002003004': '导入用户数据不能为空！',
  '1002003005': '用户密码校验失败',
  '1002003006': '名字为【{0}】的用户已被禁用',
  '1002003008': '创建用户失败，原因：超过租户最大租户配额({0})！',
  '1002003009': '初始密码不能为空',
  '1002003010': '该手机号尚未注册',
  '1002003011': '注册功能已关闭',
  '1002003012': '删除 admin 或 cadmin 用户时必须选择审批人',
  '1002004000': '已经存在该名字的租户',
  '1002004001': '父级租户不存在',
  '1002004002': '当前租户不存在',
  '1002004003': '存在子租户，无法删除',
  '1002004004': '不能设置自己为父租户',
  '1002004006': '租户({0})不处于开启状态，不允许选择',
  '1002004007': '不能设置自己的子租户为父租户',
  '1002005000': '当前岗位不存在',
  '1002005001': '岗位({0}) 不处于开启状态，不允许选择',
  '1002005002': '已经存在该名字的岗位',
  '1002005003': '已经存在该标识的岗位',
  '1002006001': '当前字典类型不存在',
  '1002006002': '字典类型不处于开启状态，不允许选择',
  '1002006003': '已经存在该名字的字典类型',
  '1002006004': '已经存在该类型的字典类型',
  '1002006005': '无法删除，该字典类型还有字典数据',
  '1002007001': '当前字典数据不存在',
  '1002007002': '字典数据({0})不处于开启状态，不允许选择',
  '1002007003': '已经存在该值的字典数据',
  '1002008001': '当前通知公告不存在',
  '1002011000': '短信渠道不存在',
  '1002011001': '短信渠道不处于开启状态，不允许选择',
  '1002011002': '无法删除，该短信渠道还有短信模板',
  '1002012000': '短信模板不存在',
  '1002012001': '已经存在编码为【{0}】的短信模板',
  '1002012002': '短信 API 模板调用失败，原因是：{0}',
  '1002012003': '短信 API 模版无法使用，原因：审批中',
  '1002012004': '短信 API 模版无法使用，原因：审批不通过，{0}',
  '1002012005': '短信 API 模版无法使用，原因：模版不存在',
  '1002013000': '手机号不存在',
  '1002013001': '模板参数({0})缺失',
  '1002013002': '短信模板不存在',
  '1002014000': '验证码不存在',
  '1002014001': '验证码已过期',
  '1002014002': '验证码已使用',
  '1002014004': '超过每日短信发送数量',
  '1002014005': '短信发送过于频繁',
  '1002015000': '租户不存在',
  '1002015001': '名字为【{0}】的租户已被禁用',
  '1002015002': '名字为【{0}】的租户已过期',
  '1002015003': '系统租户不能进行修改、删除等操作！',
  '1002015004': '名字为【{0}】的租户已存在',
  '1002015005': '域名为【{0}】的租户已存在',
  '1002016000': '租户套餐不存在',
  '1002016001': '租户正在使用该套餐，请给租户重新设置套餐后再尝试删除',
  '1002016002': '名字为【{0}】的租户套餐已被禁用',
  '1002016003': '已经存在该名字的租户套餐',
  '1002018000': '社交授权失败，原因是：{0}',
  '1002018001': '社交授权失败，找不到对应的用户',
  '1002018200': '获得手机号失败',
  '1002018201': '获得小程序码失败',
  '1002018202': '获得小程序订阅消息模版失败',
  '1002018203': '发送小程序订阅消息失败',
  '1002018204': '上传微信小程序发货信息失败',
  '1002018205': '上传微信小程序订单收货信息失败',
  '1002018210': '社交客户端不存在',
  '1002018211': '社交客户端已存在配置',
  '1002020000': 'OAuth2 客户端不存在',
  '1002020001': 'OAuth2 客户端编号已存在',
  '1002020002': 'OAuth2 客户端已禁用',
  '1002020003': '不支持该授权类型',
  '1002020004': '授权范围过大',
  '1002020005': '无效 redirect_uri: {0}',
  '1002020006': '无效 client_secret: {0}',
  '1002021000': 'client_id 不匹配',
  '1002021001': 'redirect_uri 不匹配',
  '1002021002': 'state 不匹配',
  '1002022000': 'code 不存在',
  '1002022001': 'code 已过期',
  '1002023000': '邮箱账号不存在',
  '1002023001': '无法删除，该邮箱账号还有邮件模板',
  '1002024000': '邮件模版不存在',
  '1002024001': '邮件模版 code({0}) 已存在',
  '1002025000': '模板参数({0})缺失',
  '1002025001': '邮箱不存在',
  '1002026000': '站内信模版不存在',
  '1002026001': '已经存在编码为【{0}】的站内信模板',
  '1002028000': '模板参数({0})缺失',
  '1002029000': '审批令牌无效或已过期',
  '1002029001': '审批数据无效',
  '1002029002': '审批记录不存在',
  '1002029003': '申请人信息不匹配',
  '1002029004': '审批记录状态不正确',
  '1002030000': '当前容器不存在',
  '1002030001': '已经存在该名字的容器',
  '1002030002': '已经存在该唯一ID的容器',
  '401': '账号未登录',
  '403': '没有该操作权限',
  '404': '请求未找到',
  '405': '请求方法不正确',
  '423': '请求失败，请稍后重试',
  '429': '请求过于频繁，请稍后重试',
  '500': '系统异常',
  '501': '功能未实现/未开启',
  '502': '错误的配置项',
  '900': '重复请求，请稍后重试',
  '901': '演示模式，禁止写操作',
  '999': '未知错误',
  '1001000001': '参数配置不存在',
  '1001000002': '参数配置 key 重复',
  '1001000003': '不能删除类型为系统内置的参数配置',
  '1001000004': '获取参数配置失败，原因：不允许获取不可见配置',
  '1001001000': '定时任务不存在',
  '1001001001': '定时任务的处理器已经存在',
  '1001001002': '只允许修改为开启或者关闭状态',
  '1001001003': '定时任务已经处于该状态，无需修改',
  '1001001004': '只有开启状态的任务，才可以修改',
  '1001001005': 'CRON 表达式不正确',
  '1001001006': '定时任务的处理器 Bean 不存在，注意 Bean 默认首字母小写',
  '1001001007': '定时任务的处理器 Bean 类型不正确，未实现 JobHandler 接口',
  '1001002000': 'API 错误日志不存在',
  '1001002001': 'API 错误日志已处理',
  '1001003000': '文件路径已存在',
  '1001003001': '文件不存在',
  '1001003002': '文件为空',
  '1001004002': '导入的字段不存在',
  '1001004001': '导入的表不存在',
  '1001004004': '表定义不存在',
  '1001004005': '字段义不存在',
  '1001004006': '同步的字段不存在',
  '1001004007': '同步失败，不存在改变',
  '1001004008': '数据库的表注释未填写',
  '1001004009': '数据库的表字段({0})注释未填写',
  '1001004010': '主表(id={0})定义不存在，请检查',
  '1001004011': '子表的字段(id={0})不存在，请检查',
  '1001004012': '主表生成代码失败，原因：它没有子表',
  '1001006000': '文件配置不存在',
  '1001006001': '该文件配置不允许删除，原因：它是主配置，删除会导致无法上传文件',
  '1001007000': '数据源配置不存在',
  '1001007001': '数据源配置不正确，无法进行连接',
  '1001201000': '示例联系人不存在',
  '1001201001': '示例分类不存在',
  '1001201002': '存在存在子示例分类，无法删除',
  '1001201003': '父级示例分类不存在',
  '1001201004': '不能设置自己为父示例分类',
  '1001201005': '已经存在该名字的示例分类',
  '1001201006': '不能设置自己的子示例分类为父示例分类',
  '1001201007': '学生不存在',
  '1001201008': '学生课程不存在',
  '1001201009': '学生班级不存在',
  '1001201010': '学生班级已存在',
  '1050001000': '设备类型不存在',
  '1050001001': '设备类型标识已经存在',
  '1050001002': '设备类型状是发布状态，不允许删除',
  '1050001003': '设备类型状是发布状态，不允许操作物模型',
  '1050001004': '设备类型下存在设备，不允许删除',
  '1050002000': '设备类型物模型不存在',
  '1050002001': 'deviceTypeKey 对应的设备类型物模型已存在',
  '1050002002': '存在重复的功能标识符。',
  '1050002003': '设备类型物模型标识无效',
  '1050003000': '设备不存在',
  '1050003001': '设备名称在同一设备类型下必须唯一',
  '1050003002': '有子设备，不允许删除',
  '1050003003': '设备标识已经存在',
  '1050003004': '网关设备不存在',
  '1050003005': '设备不是网关设备',
  '1050003006': '导入设备数据不能为空！',
  '1050003007': '下行设备消息失败，原因：设备未连接网关',
  '1050003008': '设备序列号已存在，序列号必须全局唯一',
  '1050004000': '设备类型分类不存在',
  '1050005000': '设备分组不存在',
  '1050005001': '设备分组下存在设备，不允许删除',
  '1050008000': '固件信息不存在',
  '1050008001': '设备类型版本号重复',
  '1050008100': '升级任务不存在',
  '1050008101': '创建 OTA 任务失败，原因：任务名称重复',
  '1050008102': '创建 OTA 任务失败，原因：设备({0})已经在升级中...',
  '1050008103': '创建 OTA 任务失败，原因：没有可升级的设备',
  '1050008104': '取消 OTA 任务失败，原因：任务状态不是进行中',
  '1050008200': '升级记录不存在',
  '1050008201': '取消 OTA 升级记录失败，原因：记录状态不是进行中',
  '1050008202': '更新 OTA 升级记录进度失败，原因：该设备没有进行中的升级记录',
  '1050010000': '数据流转规则不存在',
  '1050011000': '数据桥梁不存在',
  '1050011001': '数据流转目的正在被数据流转规则使用，无法删除',
  '1050012000': '场景联动不存在',
  '1050013000': 'IoT 告警配置不存在',
  '1050014000': 'IoT 告警记录不存在',
  '1051001000': '设备鉴权失败',
  '1051001002': 'token 失效。需重新调用 auth 进行鉴权，获取token',
  '1051002001': '设备({0}/{1}) 不存在',
}
